export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        const $teaserBoxes = document.querySelectorAll('.news-grid');

        if (!$teaserBoxes.length) {
            return;
        }

        $teaserBoxes.forEach((teaserBox) => {
            const itemselectorImageBox = '#' + teaserBox.id + ' .card-image-news-teaser img';
            const $equalHeightItemImageBox = teaserBox.querySelectorAll(itemselectorImageBox);
            const itemselectorCardBodyBox = '#' + teaserBox.id + ' .card-body';
            const $equalHeightItemCardBodyBox = teaserBox.querySelectorAll(itemselectorCardBodyBox);

            if ($equalHeightItemImageBox.length > 0) {
                window.addEventListener('load', () => {
                    equalheight(itemselectorImageBox);
                });

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        equalheight(itemselectorImageBox);
                    });
                });

                // mobile devices rotation
                window.addEventListener('orientationchange', () => {
                    setTimeout(() => {
                        equalheight(itemselectorImageBox);
                    });
                });
            }

            if ($equalHeightItemCardBodyBox.length > 0) {
                window.addEventListener('load', () => {
                    equalheight(itemselectorCardBodyBox);
                });

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        equalheight(itemselectorCardBodyBox);
                    });
                });

                // mobile devices rotation
                window.addEventListener('orientationchange', () => {
                    setTimeout(() => {
                        equalheight(itemselectorCardBodyBox);
                    });
                });
            }
        });
    });
}
